export const SUBSCRIPTION_PLANS = {
  FREE: {
    id: 'free',
    name: 'Free Viewer',
    price: 0,
    interval: 'month',
    features: [
      'View shared maps and routes',
      'Basic map features',
      'Community support',
      'Access to shared surveys'
    ],
    requiredFields: [
      'email',
      'phone',
      'name',
      'referredBy',
      'signupReason'
    ]
  },
  PROFESSIONAL: {
    id: 'professional',
    name: 'Professional',
    price: 49,
    interval: 'month',
    yearlyDiscount: 15,
    features: [
      'RoadScope survey and map module',
      'PermitPro module',
      'Create and manage surveys',
      'Advanced route planning',
      'Unlimited POIs',
      'Priority support',
      'Advanced exports',
      'Weather integration'
    ],
    requiredFields: [
      'email',
      'phone',
      'cellphone',
      'name',
      'address',
      'emergencyContact',
      'role',
      'companyName'
    ],
    addons: {
      ROADGUARD: {
        id: 'roadguard',
        name: 'RoadGuard Module',
        price: 25,
        yearlyDiscount: 15
      },
      CARGOCARE: {
        id: 'cargocare',
        name: 'CargoCare Module',
        price: 20,
        yearlyDiscount: 15
      },
      PERMITPRO: {
        id: 'permitpro',
        name: 'PermitPro Module',
        price: 20,
        yearlyDiscount: 15
      }
    }
  },
  ENTERPRISE: {
    id: 'enterprise',
    name: 'Enterprise',
    price: null,
    interval: 'year',
    features: [
      'Custom solutions',
      'API access',
      'Dedicated support',
      'Custom integrations', 
      'Team management',
      'Advanced analytics'
    ],
    requiredFields: [
      'email',
      'phone',
      'cellphone',
      'name',
      'address',
      'emergencyContact',
      'role',
      'companyName'
    ]
  },
  BETA: {
    id: 'beta',
    name: 'Beta Tester',
    price: 0,
    interval: 'month',
    features: [
      'Full platform access',
      'All modules included',
      'Early access to features',
      'Feedback required'
    ],
    requiredFields: [
      'email',
      'phone',
      'name',
      'role',
      'companyName'
    ]
  },
  PAY_AS_YOU_GO: {
    id: 'pay-as-you-go',
    name: 'Pay As You Go',
    tokenPacks: [
      {
        id: 'starter',
        name: 'Starter Pack',
        price: 49,
        tokens: 100,
        description: 'Perfect for occasional users needing route planning and map export credits.'
      },
      {
        id: 'pro',
        name: 'Pro Pack',
        price: 199,
        tokens: 500,
        description: 'Ideal for regular users requiring advanced feature access.'
      },
      {
        id: 'enterprise',
        name: 'Enterprise Pack',
        price: 349,
        tokens: 1000,
        description: 'Best value for teams with extended validity and custom solutions.'
      }
    ],
    features: [
      'Purchase tokens as needed',
      'Access any module',
      'No monthly commitment',
      'Tokens never expire'
    ],
    requiredFields: [
      'email',
      'phone',
      'name',
      'address'
    ]
  }
};